<latch-card headerTitle="You can close this window">
  <button latchCardFooter class="latch-button latch-dark" (click)="goToUrl()">Close window</button>
</latch-card>
